<template>
  <section class="tone-page-banner" data-buried="Banner">
    <h1 class="tone-page-banner-title font-dt">
      零基础搞定专业配音<br />
      AI语音让视频"声"动人心
    </h1>
    <div class="tone-page-banner-sub">
      <p>
        寻找能表达情感的AI配音？魔珐有言提供高仿真的文字转语音服务，并支持独家声音克隆。生成语音可精准驱动数字人口型，
      </p>
      <p>为您的视频教程、营销内容与有声书注入专业灵魂，让表达栩栩如生。</p>
    </div>
    <ArrowBtn
      class="tone-page-banner-button"
      text="免费试用"
      variant="black-large"
      @click="emits('handler')"
    />
    <BannerPlayer />
  </section>
</template>

<script lang="ts" setup>
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';
import BannerPlayer from './BannerPlayer.vue';

const emits = defineEmits<{
  (e: 'handler'): void;
}>();
</script>
<style lang="scss" scoped src="./styles/pc.scss"></style>
<style lang="scss" scoped src="./styles/mobile.scss"></style>
